export default __webpack_public_path__ + "static/plp--bundle--reposado-4ccd06885889e46cda3a625f31dcec90.png";